import React, { useContext } from 'react';

import { QuartileScales } from '@/components/shared/QuartileScales/QuartileScales';
import { SetlistsContext } from '@/providers/SetlistsProvider';

import { GenerateSetlistContext } from '../../GenerateSetlist';
import AnalysisCard from '../AnalysisCard/AnalysisCard';
import AnalysisGateCard from '../AnalysisGateCard/AnalysisGateCard';
import styles from './QuartilesReport.module.scss';

const QuartilesReport: React.FC<{
	setlist: SetlistsContext['setlists'][0];
}> = ({ setlist }) => {
	const { setFeedbackSetlistId } = useContext(GenerateSetlistContext);

	return setlist.feedback ? (
		<AnalysisCard title="Average sentiment" >
			<QuartileScales
				quartiles={setlist.feedback}
			/>
		</AnalysisCard>
	) : (
		<AnalysisCard title="Average sentiment" >
			<div className={styles['wrapper']}>
				<QuartileScales
					quartiles={{
						personalScoreQuartiles: {
							q1: 3,
							q2: 4.2,
							q3: 5,
						},
						teamScoreQuartiles: {
							q1: 4,
							q2: 4.7,
							q3: 5,
						},
						congregationalScoreQuartiles: {
							q1: 3,
							q2: 3.4,
							q3: 4,
						},
					}}
				/>
				<AnalysisGateCard
					body="Add your feedback to get a summary"
					ctaLabel="Give Feedback"
					onCtaClick={() => setFeedbackSetlistId(setlist.id)}
				/>
			</div>
		</AnalysisCard>
	);
};

export default QuartilesReport;
